import React, {Fragment} from "react";
import {Grid, TextField, Typography, CircularProgress, Button} from "@material-ui/core";
import {Autocomplete} from "@material-ui/lab";
import Widget from "../../components/BetterWidget";
import Rest from "../../helpers/Rest";

export class PersonReport extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            options: [],
            generating: false
        }
    }

    fetch(value){
        if (!/\w+/.test(value)){
            this.setState({
                options: [],
                loading: false
            })
            return
        }
        Rest.get("report/person/" + window.encodeURIComponent(value)).then(reply => {
            if (value !== this.state.person){
                this.setState({options: reply})
                this.fetch(this.state.person)
            }
            else{
                this.setState({
                    options: reply,
                    loading: false
                })
            }
        })
    }

    autocomplete(e){
        const value = e.target.value
        console.log(value)
        if (this.state.loading){
            this.setState({
                person: value
            })
            return
        }
        if (!/\w+/.test(value)){
            this.setState({
                options: [],
                person: value
            })
            return
        }
        this.setState({
            loading: true,
            person: value
        })
        this.fetch(value)
    }

    textField(props){
        return (
            <TextField
                {...props}
                variant="outlined"
                label="Person"
                onChange={this.autocomplete.bind(this)}
                InputProps={{
                    ...props.InputProps,
                    endAdornment: (
                        <Fragment>
                            {this.state.loading ? <CircularProgress color="primary" size={20}/> : null}
                            {props.InputProps.endAdornment}
                        </Fragment>
                    )
                }}
                fullWidth
            />
        )
    }

    download(){
        const {person} = this.state
        const uri = "report/contact/" + window.encodeURIComponent(person)
        this.setState({
            generating: true
        })
        Rest.getCsv(uri, `${person.replace(/\s+/g, '-')}-report.csv`).then(() => {
            this.setState({
                generating: false
            })
        })
    }

    enabled() {
        const {person, options} = this.state
        if (!person){
            return false
        }
        return !!options.find(opt => opt === person)
    }

    setValue(e, value) {
        this.setState({
            person: value
        })
    }

    button(){
        return (
            <Button
                variant="contained"
                color="primary"
                onClick={this.download.bind(this)}
                disabled={!this.enabled()}
            >Save Report</Button>
        )
    }

    progress(){
        return (
            <Fragment>
                Generating report...<CircularProgress color="primary"/>
            </Fragment>
        )
    }

    render(){
        const {options, loading, generating} = this.state
        return (
            <Widget>
                <Grid container spacing={2} className={this.props.className}>
                    <Grid item xs={12}>
                        <Typography variant="h3">Contact Report</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Autocomplete
                            options={options}
                            loading={loading}
                            onChange={this.setValue.bind(this)}
                            renderInput={this.textField.bind(this)}/>
                    </Grid>
                    <Grid container item xs={12} sm={6} justify="flex-end" alignItems="center">
                        {generating ? this.progress() : this.button()}
                    </Grid>
                </Grid>
            </Widget>
        )
    }
}